import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { scrollToSection } from "@/App";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#111111] text-[#F9F8F5] px-6 py-12">
    <div className="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-center justify-between gap-6">
      <button
        onClick={() => scrollToSection("#top")}
        data-testid="footer-wordmark"
        className="font-cinzel text-lg tracking-[0.2em] text-left hover:opacity-80 transition-opacity duration-300"
      >
        HAILEY <span className="text-bronze">&amp;</span> CHLOE
      </button>
      <div className="flex items-center gap-6">
        <button
          data-testid="footer-link-portfolio"
          onClick={() => scrollToSection("#maisons")}
          className="text-sm text-[#F9F8F5]/70 hover:text-bronze transition-colors duration-300"
        >
          Portfolio
        </button>
        <button
          data-testid="footer-link-contact"
          onClick={() => scrollToSection("#inquiries")}
          className="text-sm text-[#F9F8F5]/70 hover:text-bronze transition-colors duration-300"
        >
          Contact
        </button>
        <Link
          to="/admin"
          data-testid="footer-link-admin"
          className="inline-flex items-center gap-1.5 text-sm text-[#F9F8F5]/70 hover:text-bronze transition-colors duration-300"
        >
          <Lock className="w-3.5 h-3.5" />
          Back office
        </Link>
      </div>
    </div>
    <div className="max-w-5xl mx-auto mt-8 border-t border-white/10 pt-6">
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#F9F8F5]/40">
        © Hailey and Chloe Holdings Inc. All rights reserved.
      </p>
    </div>
  </footer>
);
